import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CertificateBruger } from 'src/app/api/models';
import { ProfilService } from 'src/app/api/services';
import { ErrorService } from 'src/app/core/error-handling/error.service';
import { NotificationService } from 'src/app/core/notifications/notification.service';
import { TekstResourcePipe } from 'src/app/core/pipes/tekstresource.pipe';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { SaveOperationsService } from 'src/app/core/services/operations/save/save-operations.service';

@Injectable({
  providedIn: 'root',
})
export class CurrentProfilService {
  profilInformation$ = new BehaviorSubject<CertificateBruger>(null);

  constructor(
    private authService: AuthService,
    private profilService: ProfilService,
    private errorService: ErrorService,
    private saveOperationsService: SaveOperationsService,
    private notificationService: NotificationService,
    private tekstResourcePipe: TekstResourcePipe
  ) {}

  getProfilInformation() {
    return this.profilService
      .get()
      .toPromise()
      .then(profil => {
        this.profilInformation$.next(profil);
      })
      .catch(err => {
        this.errorService.log(err);
        this.notificationService.error(this.tekstResourcePipe.transform('_ErrorRefresh'));
      });
  }

  updateProfilInformation(updatedProfil: CertificateBruger) {
    const saveOperation = this.saveOperationsService.addOperation();
    this.profilService
      .put({ id: this.profilInformation$.value.id, profil: updatedProfil })
      .toPromise()
      .then(profil => {
        this.profilInformation$.next(profil);
        if (!!this.authService.user) {
          this.authService.getUserInfo().subscribe(() => {
            saveOperation.complete();
          });
        }
      })
      .catch(err => {
        this.errorService.log(err);
        saveOperation.fail();
      });
  }
}
